import { IEditBusinessCustomerPlaceFormValues } from 'features/BusinessCustomer/types'
import { IntlShape, defineMessages } from 'react-intl'
import { ZIP_CODE_REGEX } from 'utils/address'
import { LATITUDE_REGEX_STRING, LONGITUDE_REGEX_STRING } from 'utils/google-maps'
import * as yup from 'yup'

const streetMessages = defineMessages({
  required: {
    id: 'businessCustomer.editBusinessCustomerPlaceModal.street.required',
    defaultMessage: 'Street is required'
  }
})

const zipCodeMessages = defineMessages({
  required: {
    id: 'businessCustomer.editBusinessCustomerPlaceModal.zipCode.required',
    defaultMessage: 'Zip code is required'
  },
  format: {
    id: 'businessCustomer.editBusinessCustomerPlaceModal.zipCode.format',
    defaultMessage: 'Zip code is not valid'
  }
})

const cityMessages = defineMessages({
  required: {
    id: 'businessCustomer.editBusinessCustomerPlaceModal.city.required',
    defaultMessage: 'City is required'
  }
})

const latitudeMessages = defineMessages({
  required: {
    id: 'businessCustomer.editBusinessCustomerPlaceModal.latitude.required',
    defaultMessage: 'Latitude is required'
  },
  format: {
    id: 'businessCustomer.editBusinessCustomerPlaceModal.latitude.format',
    defaultMessage: 'Latitude is not valid'
  }
})

const longitudeMessages = defineMessages({
  required: {
    id: 'businessCustomer.editBusinessCustomerPlaceModal.longitude.required',
    defaultMessage: 'Longitude is required'
  },
  format: {
    id: 'businessCustomer.editBusinessCustomerPlaceModal.longitude.format',
    defaultMessage: 'Longitude is not valid'
  }
})

export const schema = (intl: IntlShape): yup.SchemaOf<IEditBusinessCustomerPlaceFormValues> => {
  return yup.object().shape({
    street: yup.string().required(intl.formatMessage(streetMessages.required)),
    zipCode: yup
      .string()
      .matches(ZIP_CODE_REGEX, intl.formatMessage(zipCodeMessages.format))
      .required(intl.formatMessage(zipCodeMessages.required)),
    city: yup.object().shape({
      id: yup.string().required(intl.formatMessage(cityMessages.required)),
      name: yup.string().required(intl.formatMessage(cityMessages.required))
    }),
    location: yup.object().shape({
      latitude: yup
        .string()
        .matches(new RegExp(LATITUDE_REGEX_STRING), intl.formatMessage(latitudeMessages.format))
        .required(intl.formatMessage(latitudeMessages.required)),
      longitude: yup
        .string()
        .matches(new RegExp(LONGITUDE_REGEX_STRING), intl.formatMessage(longitudeMessages.format))
        .required(intl.formatMessage(longitudeMessages.required))
    })
  })
}
